/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

export class LinkedContentApi {
    constructor(api) {
        this.api = api;
    }

    async get(id) {
        return await this.api.get(`/linkedcontents/${id}`);
    }
}
